import { appInfo } from "@/common/data/appinfo";

export default [
  {
    path: "/LzfsAN5zHOJVgfw4V8QHjL10d2fShKvQ",
    children: [
      {
        path: "jL10d2fShKvQ",
        name: "graduation-class",
        meta: {
          authRequired: true,
          title: appInfo?.type === "codsms" ? "Graduated Classes" : "Convocated Sets",
          acc: ["v54"],
        },
        component: () => import("../views/graduation-class/index.vue"),
      },
     
      {
        path: "PgucwTjPTnmK3TR8aLHwjL10d2fShKvQ",
        name: "new-gradclass",
        meta: {
          authRequired: true,
          title: appInfo?.type === "codsms" ? "New Graduation Set" : "New Convocation Set",
          acc: ["v52"],
        },
        component: () => import("../views/graduation-class/new.vue"),
      },
      {
        path: "bZu3dPLkswGWmGO7D7DtjL10d2fShKvQ",
        name: "view-gradclass",
        meta: {
          authRequired: true,
          title: "Graduated Class",
          acc: ["v52"],
        },
        component: () => import("../views/graduation-class/view.vue"),
      },
    ],
  },
];
